import { MenuFilter } from "@/common/MenuFilter";
import { DirectionIcon } from "@/common/DirectionIcon";
import type { NotesTableColumnGetter, NotesTableColumnsProps } from "../types";
import type { NotesTableRowData } from "../types/notes-table-types";
import { NOTES_TABLE_COLUMNS_KEYS } from "../notes-table-columns-keys";
import styles from "./styles/styles.module.scss";

export type NotesTableDirectionColumnProps = NotesTableColumnsProps<{
  menuFilters?: MenuFilter[];
  onChangeMenuFilters?: (selected: string[]) => void;
}>;

export type NotesTableDirectionColumnGetter =
  NotesTableColumnGetter<NotesTableDirectionColumnProps>;

export const getNotesTableDierctionColumn: NotesTableDirectionColumnGetter = ({
  title = "",
  dataIndex = ["direction"],
  onHeaderCell = () => ({
    className: styles["direction-header"],
  }),
  key = NOTES_TABLE_COLUMNS_KEYS.direction,
  width = 50,
  sorter = (a: NotesTableRowData) => (a?.direction === "INCOMING" ? 1 : -1),
  onFilter = (value, record) => {
    return record?.direction?.includes(value as string) ?? false;
  },
  menuFilters = [],
  showSorterTooltip = false,

  onChangeMenuFilters = () => "",
  filterDropdown = () => <MenuFilter onChange={onChangeMenuFilters} filters={menuFilters} />,
  render = (_, record) => {
    return <DirectionIcon record={record as NotesTableRowData} />;
  },
  ...props
}) => {
  return {
    title: title,
    dataIndex: dataIndex,
    onHeaderCell: onHeaderCell,
    key: key,
    width: width,
    sorter: sorter,
    filterDropdown: filterDropdown,
    onFilter: onFilter,
    render: render,
    showSorterTooltip: showSorterTooltip,
    ...props,
  };
};
